import find from 'lodash/find.js';

import Model from '@/models/Model.js';

export default class Quiz extends Model {
    static entity = 'quizzes';

    static modelName = 'Quiz';

    static state() {
        return {
            refresh_key: 0,
        };
    }

    static fields() {
        return {
            id: this.attr(null),
            title: this.attr(null),
            attempts_count: this.attr(null),
            questions_per_page: this.attr(null),
            question_count: this.attr(null),
            random_question_order: this.attr(null),
            must_answer_in_order: this.attr(null),
            calculator_enabled: this.attr(null),
            groups: this.attr(null),
            type: this.attr(null),
            version: this.attr(null),
            points_possible: this.attr(null),
            versions: this.attr(null),
            locked_for_editing: this.boolean(false),

            ...super.fields(),

            // questions: this.hasMany('questions', 'quiz_id'),
            course_codes: this.morphToMany(
                'course-codes',
                'course_codeables',
                'course_code_id',
                'course_codeable_id',
                'course_codeable_type'
            ),
            tags: this.morphToMany('tags', 'taggables', 'tag_id', 'taggable_id', 'taggable_type'),
            automated_survey_assignments: this.hasMany('automated_survey_assignments', 'survey_id'),
        };
    }

    currentVersion(versions) {
        const model = this.type === 'quiz' ? 'App\\Models\\Quiz' : 'App\\Models\\Survey';

        return find(versions, { versionable_id: this.id, versionable_type: model });
    }

    isUsingLatestVersion(versions) {
        const versionUsed = this.currentVersion(versions);

        if (!versionUsed) {
            throw new Error(`Could not identify which ${this.type} version is being used.`);
        }

        return versionUsed.is_latest;
    }
}
